export enum Button {
  Reset = 'reset',
  Check = 'check',
  Language = 'lang',
  Preview = 'preview',
  Help = 'help',
  Custom = 'custom',
  ZoomIn = 'zoom-in',
  ZoomOut = 'zoom-out',
  Joker = 'joker',
  Privacy = 'privacy',
  Fullscreen = 'fullscreen',
  DatePicker = 'date-picker',
  PuzzlePicker = 'puzzle-picker',
  AddAllNotes = 'add-all-notes',
  DifficultyPicker = 'difficulty-picker',
  ImageShiftUp = 'image-shift-up',
  ImageShiftDown = 'image-shift-down',
  ImageShiftLeft = 'image-shift-left',
  ImageShiftRight = 'image-shift-right',
  NotesToggle = 'notes-toggle',
  Sweepstake = 'sweepstake',
  LanguagePicker = 'language-picker',
  MenuToggle = 'menu',
  Spacer = 'spacer',
  DisableAutoZoom = 'auto-zoom',
  ZoomFull = 'zoom-full',
  SettingsDivider = 'settings-divider',
  InfoDivider = 'info-divider',
  MenuDivider = 'menu-divider',
  ToggleDefinitionBar = 'definition-bar',
  ToggleHighlightRightAndWrong = 'highlight-right-and-wrong',
  ToggleShowErrorsImmediately = 'show-errors-immediately',
  ToggleHighContrast = 'high-contrast',
  ToggleDarkMode = 'dark-mode',
  ToggleWordJump = 'word-jump',
  AutoMove = 'auto-move',
  ToggleSkipFilledFields = 'skip-filled-fields',
  NativeKeyboard = 'native-keyboard',
  KeepKeyboardOpen = 'keep-keyboard-open',
  ShowSolution = 'show-solution',
  Updates = 'updates',
  SettingsMenu = 'settings-menu',
  Feedback = 'feedback',
  Print = 'print',
  LeaderboardReview = 'leaderboard-review',
}
